import { z } from 'zod';
export const AgentSessionFilterModeSchema = z.enum(['AllSessions', 'OnlySessionsWithMessages']);
const AgentSessionLabelSchema = z.string().trim().min(1).max(200);
export const AgentSessionSummarySchema = z.object({
    created: z.iso.datetime(),
    id: z.uuidv7(),
    /** Secondary label chosen by the client. Null for sessions a run created implicitly. */
    subtitle: AgentSessionLabelSchema.nullable(),
    /** Display label chosen by the client. Null for sessions a run created implicitly. */
    title: AgentSessionLabelSchema.nullable(),
    updated: z.iso.datetime(),
    userId: z.uuid(),
});
export const AgentSessionSummariesSchema = z.array(AgentSessionSummarySchema);
export const CreateAgentSessionRequestSchema = z.object({
    subtitle: AgentSessionLabelSchema.optional(),
    title: AgentSessionLabelSchema.optional(),
});
/** A `null` label clears it; a missing label leaves it as it is. */
export const UpdateAgentSessionRequestSchema = z.object({
    subtitle: AgentSessionLabelSchema.nullable().optional(),
    title: AgentSessionLabelSchema.nullable().optional(),
});
//# sourceMappingURL=summary.js.map